import './Highlights.css';
export default {
    "wrapper": "Highlights_wrapper__1djuo",
    "highlightItem": "Highlights_highlightItem__1djuo",
    "ageRestriction": "Highlights_ageRestriction__1djuo",
    "body": "Highlights_body__1djuo"
};
